import React from 'react';

const FolderOutlineSVG: React.FC<React.SVGProps<SVGSVGElement>> = props => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="-8 -8 592 528"
      fill="none"
      stroke="currentColor"
      strokeWidth="20"
      strokeLinejoin="round"
      strokeLinecap="round"
      width="100%"
      height="100%"
      style={{ display: 'block' }}
      {...props}
    >
      <path d="M88.7 223.8L0 375.8V96C0 60.7 28.7 32 64 32H181.5c17 0 33.3 6.7 45.3 18.7l26.5 26.5c12 12 28.3 18.7 45.3 18.7H416c35.3 0 64 28.7 64 64v32H144c-22.8 0-43.8 13.6-53.3 34.8zM22.2 432l.2-.2 96.5-168.8A48 48 0 0 1 160 240H544c15.3 0 29.4 8.3 36.7 21.6s6.9 29.5-.7 42.4L487.2 464c-9.4 17.5-27.8 28-47.6 28H64c-22.8 0-43.8-13.4-53.4-34l-.5-1.1-.6-1.5-.7-3-.6-2.4 .3-.3 13.5-20z" />
    </svg>
  );
};

export { FolderOutlineSVG };
